(ns teamoesterreich.user-mode.core
  (:require
    [reagent-material-ui.components :as mui]
    [reagent.core :as r]                                    ;usage

    [teamoesterreich.store :as store]
    [teamoesterreich.style.toe-material-style :as m-style]

    [teamoesterreich.text.get-text :as txt]
    [teamoesterreich.user-mode.navigation.app-bar :as app-bar]
    ;[teamoesterreich.firebase.auth :as fb-auth]


    [teamoesterreich.user-mode.navigation.bottom-bar :as bottom-bar]
    [teamoesterreich.user-mode.page-router :as page-router]
    [teamoesterreich.user-mode.syncer :as syncer]
    )

  (:import (goog.i18n DateTimeSymbols_de_AT)))




(defn main []
  (let [!loadFinished (r/cursor store/app-state [:loadingFinished])
        !uid (r/cursor store/app-state [:firebase-uid])
        !act-site (r/cursor store/app-state [:site])
        !load-error (r/cursor store/app-state [:load-error])
        !login-error (r/cursor store/app-state [:login-error])
        ]
    (syncer/get-all)
    (fn []
      [:<>
       [mui/css-baseline]

       [(m-style/with-toe-styles app-bar/bar)]
       [:div {:style {:minHeight "calc(100vh - 70px)"}}
        [:span {:style {:display "none"}} (str @!uid)]

        (if @!loadFinished
          [:<>
           [page-router/get-page !act-site]

           (when @!load-error
             [mui/dialog
              {:justifyContent "center"
               :fullWidth      true
               :maxWidth       "md"
               :open           (true? @!load-error)
               :onClose        #(reset! !load-error false)}
              [mui/dialog-title
               {:onClose #(reset! !load-error false)}
               "Fehler"]
              [mui/dialog-content
               [:div "Beim Laden der Seite ist ein Fehler aufgetreten."]
               ]]
             )

           (when @!login-error
             [mui/dialog
              {:justifyContent "center"
               :fullWidth      true
               :maxWidth       "md"
               :open           (true? @!login-error)
               :onClose        #(reset! !login-error false)}
              [mui/dialog-title
               {:onClose #(reset! !login-error false)}
               "Fehler"]
              [mui/dialog-content
               [:div "Beim Login ist ein Fehler aufgetreten."]
               ]]
             )
           ]

          [mui/paper
           [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}]
           [:h3 (str (txt/txt :core "Lade dein Team Profil"))]
           ]
          )
        ]

       [bottom-bar/bar]

       ])))


